import React from 'react'
import { bool, string, node, oneOfType } from 'prop-types'
import * as Styled from './ComparedDataRow.styles'

// components
import { Icon } from 'components/atoms'
import { WordHints } from 'components/molecules'

/**
 * comparing dynamic data props
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ComparedDataRow = (props) => {
  const {
    bestValue,
    hint,
    title,
    children,
    qsrIndicator,
    withOutTooltip,
    className,
    ...rest
  } = props

  const getWordHint = () => (
    <WordHints className='word-hint' title={ title } hint={ hint } />
  )

  const compareRowClass = `${ bestValue ? 'bestValue' : '' } ${
    !!className ? className : ''
  } `.trim()

  return (
    <Styled.ComparedDataRow className={ compareRowClass } { ...rest }>
      {!withOutTooltip &&
        (qsrIndicator ? (
          <div className='row-item'>
            {getWordHint()}
            {qsrIndicator}
          </div>
        ) : (
          getWordHint()
        ))}
      <div className={ `dataRow ${ withOutTooltip ? 'withOutTooltip' : '' }` }>
        {children}
        {bestValue && !qsrIndicator && (
          <div className={ 'checkmark-icon' }>
            <Icon className='icon-f-checkmark' />
          </div>
        )}
      </div>
    </Styled.ComparedDataRow>
  )
}

ComparedDataRow.defaultProps = {
  title: false,
  hint: false,
  bestValue: false,
  qsrIndicator: false,
  withOutTooltip: false,
  className: false,
}

ComparedDataRow.propTypes = {
  bestValue: bool,
  title: oneOfType([bool, string]),
  hint: oneOfType([bool, string]),
  children: node.isRequired,
  qsrIndicator: node,
  withOutTooltip: bool,
  className: oneOfType([bool, string]),
}

export default ComparedDataRow
